import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/ErrorPage.css';

function ErrorPage({ error, onRetry }) {
  const navigate = useNavigate();

  const getErrorMessage = () => {
    if (!error) return '알 수 없는 오류가 발생했습니다.';
    
    switch (error.status) {
      case 400:
        return '잘못된 요청입니다. 입력 정보를 확인해주세요.';
      case 403:
        return '접근이 거부되었습니다.';
      case 422:
        return '입력 데이터를 처리할 수 없습니다. 형식을 확인해주세요.';
      case 500:
        return '서버 내부 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
      case 0:
        return error.message || '네트워크 연결을 확인해주세요.';
      default:
        return error.message || '문의 제출 중 오류가 발생했습니다.';
    }
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#ff6b6b" strokeWidth="2"/>
            <line x1="15" y1="9" x2="9" y2="15" stroke="#ff6b6b" strokeWidth="2"/>
            <line x1="9" y1="9" x2="15" y2="15" stroke="#ff6b6b" strokeWidth="2"/>
          </svg>
        </div>
        
        <h2 className="error-title">문의 제출 실패</h2>
        <p className="error-message">{getErrorMessage()}</p>
        
        {error?.errorCode && (
          <p className="error-code">오류 코드: {error.errorCode}</p>
        )}
        
        <div className="error-actions">
          {onRetry && (
            <button className="retry-button" onClick={onRetry}>
              다시 시도
            </button>
          )}
          <button className="back-button" onClick={handleGoBack}>
            이전 페이지
          </button>
          <button className="home-button" onClick={handleGoHome}>
            홈으로 가기
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage; 